import { Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import AnalyticsPage from './pages/AnalyticsPage';

interface IProps {}

export function Analytics(props: IProps) {
  return (
    <Switch>
      <Route path={RouteConstants.analytics.index} component={AnalyticsPage} />
    </Switch>
  );
}
